export default __webpack_public_path__ + "static/media/ct-02.45f93cde.jpg";